import { ContentNugget, toolTransform } from '@backrs_ui/common-ui';

import { useGetToolsQuery } from '@backrs_ui/grow-ui/src/redux/tools/tools.api';

const GUIDE_TOOL_IDS = [
  'college_application_roadmap_guide',
  'college_visit_guide',
  'gpa_guide',
  'course_selection_guide',
  'internships_guide',
  'standardized_tests_guide',
  'study_habits_guide',
  'common_app_essay_guide',
  'extracurriculars_guide',
  'majors_and_courses',
  'online_reputation_guide',
] as const;

export const useToolsGuidesSection = (): ContentNugget[] => {
  const { data: tools } = useGetToolsQuery(undefined);

  return GUIDE_TOOL_IDS.map((toolId) => tools?.find((tool) => tool.tool_id === toolId))
    .filter((tool): tool is NonNullable<typeof tool> => !!tool)
    .map(toolTransform);
};
